import setLibPhoneNumberMetaData from './setLibPhoneNumberMetaData'
const getLibPhoneNumberMinMetaData = (isMobile = false) => {
	if (isMobile && sessionStorage.getItem('mobile_min_json')) {
		return JSON.parse(sessionStorage.getItem('mobile_min_json'))
	} else if (sessionStorage.getItem('min_json')) {
		return JSON.parse(sessionStorage.getItem('min_json'))
	} else {
		setLibPhoneNumberMetaData()
	}
	return null
}
export default getLibPhoneNumberMinMetaData
